/* src/app/modules/user/partnersequity/partners/partners-dialog-delete.component.css */
/*# sourceMappingURL=partners-dialog-delete.component.css.map */
